import script from "./MarkdownEditorToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownEditorToolbar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/viktor/Desktop/projects/u2c/x5-group/mission-accomplished/backend/project/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"MarkdownEditorToolbar.vue"]])

export default __exports__